import React from "react";
import { IconButton, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import Button from "components/atoms/Button";
import * as Styled from "./styles";

interface DriverEditCancelConfirmationModalProps {
  open: boolean;
  onContinueEditing: () => void;
  onConfirmCancel: () => void;
}

function DriverEditCancelConfirmationModal({
  open,
  onContinueEditing,
  onConfirmCancel,
}: DriverEditCancelConfirmationModalProps) {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onContinueEditing}>
      <Styled.CancelModalContainer>
        <Styled.CancelModalHeader>
          <Styled.CancelModalTitle>{t("cancelAction")}</Styled.CancelModalTitle>
          <IconButton
            size="medium"
            aria-label={t("close")}
            onClick={onContinueEditing}
          >
            <CloseIcon />
          </IconButton>
        </Styled.CancelModalHeader>

        <Styled.CancelModalBody>
          <Styled.CancelModalMessage>
            {t("mapDriversCancelModalMessage")}
          </Styled.CancelModalMessage>
        </Styled.CancelModalBody>

        <Styled.CancelModalFooter>
          <Button
            variant="text"
            color="primary"
            onClick={onContinueEditing}
            sx={Styled.continueEditingButtonSx}
          >
            {t("continueEditing")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onConfirmCancel}
            sx={Styled.confirmCancelButtonSx}
          >
            {t("mapDriversCancelModalConfirm")}
          </Button>
        </Styled.CancelModalFooter>
      </Styled.CancelModalContainer>
    </Modal>
  );
}

export default React.memo(DriverEditCancelConfirmationModal);
